// extracted by mini-css-extract-plugin
export default {"cls1":"VeloSummary-Column_cls1__tY9Gi","cls2":"VeloSummary-Column_cls2__NsNMo VeloSummary-Column_cls1__tY9Gi"};